module.exports = __webpack_public_path__ + "img/5.4c7a3dc3.png";